const btns = document.querySelectorAll('button');
const links = document.querySelectorAll('a[href]');

const removeFocus = () => {
    if (!links) {
        return;
    }

    links.forEach((link) => {
        link.addEventListener('click', () => {
            link.blur();
        });
    });

    btns.forEach((button) => {
        if (!btns) {
            return;
        }

        button.addEventListener('click', () => {
            button.blur();
        });
    });
};

export {removeFocus};
